import { TimeValue } from '@gig/magic-common';
import { USER_TIMESTAMP_PREFERENCES_QUERY, USER_LOGGED_IN_UPDATED, USER_JURISDICTION_QUERY, USER_PREFERENCES_LOADING_UPDATED, USER_UPDATE_PREFERENCES_COMMAND, USER_RESET_PREFERENCES_COMMAND, USER_FETCH_PREFERENCES_COMMAND, USER_SHOW_GAMES_QUERY, USER_SHOW_SPORTSBOOK_QUERY, USER_UPDATE_PREFERENCES_UPDATED, USER_UPDATE_PREFERENCES_UPDATE_FAILED } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { Jurisdiction } from '@gig/magic-jurisdictions/dist/jurisdictions.constants';

var UserPlayControlService = /** @class */ (function () {
    function UserPlayControlService() {
        this.playControlPreferences = null;
        this.timeStamp = new Date();
        this.loading = false;
        this.casinoQueryHandlerSubscription = null;
        this.sportsBookQueryHandlerSubscription = null;
        this.registerPreferencesQueryHandler();
        this.registerPreferencesUpdateHandler();
        this.registerFetchPreferencesHandler();
        this.registerPreferencesResetHandler();
        this.handleSessionChange();
    }
    UserPlayControlService.prototype.sanitizePreference = function (preference, defaultValue) {
        return typeof preference === 'boolean' ? preference : defaultValue;
    };
    UserPlayControlService.prototype.registerPreferencesQueryHandler = function () {
        var _this = this;
        this.registerQueryHandlers();
        window.queryBus.subscribe(USER_TIMESTAMP_PREFERENCES_QUERY, function () {
            return _this.timeStamp;
        });
    };
    UserPlayControlService.prototype.handleSessionChange = function () {
        var _this = this;
        window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, function (e) { return __awaiter(_this, void 0, void 0, function () {
            var isLoggedIn, jurisdiction, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        isLoggedIn = !!e.payload;
                        return [4 /*yield*/, window.queryBus.query(USER_JURISDICTION_QUERY)];
                    case 1:
                        jurisdiction = _b.sent();
                        _a = jurisdiction;
                        switch (_a) {
                            case Jurisdiction.SGA: return [3 /*break*/, 2];
                            case Jurisdiction.LOTBA: return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 6];
                    case 2:
                        if (!isLoggedIn) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.loadUserPlayControlPreferences()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                    case 5:
                        if (isLoggedIn) {
                            return [2 /*return*/, this.loadUserPlayControlPreferences()];
                        }
                        else {
                            this.publishPreferences({
                                showCasinoGames: true,
                                showSportsbook: true,
                                limitsConfirmed: false,
                            });
                        }
                        return [2 /*return*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); }, { replay: true });
    };
    UserPlayControlService.prototype.loadUserPlayControlPreferences = function () {
        return __awaiter(this, void 0, void 0, function () {
            var preferences, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.timeStamp = new Date();
                        this.unsubscribeQueries();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.loading = true;
                        window.eventBus.publish(USER_PREFERENCES_LOADING_UPDATED, true);
                        return [4 /*yield*/, magic.methods.users.getPreferences()];
                    case 2:
                        preferences = (_a.sent());
                        this.publishPreferences(preferences);
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        // eslint-disable-next-line no-console
                        console.log('unable to update preferences', e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        window.eventBus.publish(USER_PREFERENCES_LOADING_UPDATED, false);
                        this.registerQueryHandlers();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    UserPlayControlService.prototype.getPlayControlPreferences = function () {
        return this.playControlPreferences
            ? this.playControlPreferences
            : {
                showCasinoGames: true,
                showSportsbook: true,
                limitsConfirmed: false,
            };
    };
    UserPlayControlService.prototype.registerPreferencesUpdateHandler = function () {
        var _this = this;
        window.commandBus.register(USER_UPDATE_PREFERENCES_COMMAND, {
            type: 'object',
            properties: {
                showGames: {
                    type: 'boolean',
                },
                showSportsbook: {
                    type: 'boolean',
                },
                limitsConfirmed: {
                    type: 'boolean',
                },
            },
        });
        window.commandBus.subscribe(USER_UPDATE_PREFERENCES_COMMAND, function (message) {
            if (!message.payload) {
                return;
            }
            return _this.doUpdateCall(message.payload);
        });
    };
    UserPlayControlService.prototype.registerPreferencesResetHandler = function () {
        var _this = this;
        window.commandBus.subscribe(USER_RESET_PREFERENCES_COMMAND, function () {
            return _this.doUpdateCall({
                showSportsbook: true,
                showCasinoGames: true,
                limitsConfirmed: false,
            });
        });
    };
    UserPlayControlService.prototype.registerFetchPreferencesHandler = function () {
        var _this = this;
        window.commandBus.subscribe(USER_FETCH_PREFERENCES_COMMAND, function () {
            var currentTime = new Date();
            if (currentTime.getTime() - _this.timeStamp.getTime() >
                10 * TimeValue.SECOND) {
                return _this.loadUserPlayControlPreferences();
            }
        });
    };
    UserPlayControlService.prototype.unsubscribeQueries = function () {
        var _a, _b;
        (_a = this.casinoQueryHandlerSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.sportsBookQueryHandlerSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        this.casinoQueryHandlerSubscription = null;
        this.sportsBookQueryHandlerSubscription = null;
    };
    UserPlayControlService.prototype.registerQueryHandlers = function () {
        var _this = this;
        if (!this.casinoQueryHandlerSubscription) {
            this.casinoQueryHandlerSubscription = window.queryBus.subscribe(USER_SHOW_GAMES_QUERY, function () {
                var _a;
                return (_a = _this.playControlPreferences) === null || _a === void 0 ? void 0 : _a.showCasinoGames;
            });
        }
        if (!this.sportsBookQueryHandlerSubscription) {
            this.sportsBookQueryHandlerSubscription = window.queryBus.subscribe(USER_SHOW_SPORTSBOOK_QUERY, function () {
                var _a;
                return (_a = _this.playControlPreferences) === null || _a === void 0 ? void 0 : _a.showSportsbook;
            });
        }
    };
    UserPlayControlService.prototype.publishPreferences = function (preferences) {
        var oldValues = this.getPlayControlPreferences();
        this.playControlPreferences = {
            showCasinoGames: this.sanitizePreference(preferences.showCasinoGames, oldValues.showCasinoGames),
            showSportsbook: this.sanitizePreference(preferences.showSportsbook, oldValues.showCasinoGames),
            limitsConfirmed: this.sanitizePreference(preferences.limitsConfirmed, false),
        };
        window.eventBus.publish(USER_UPDATE_PREFERENCES_UPDATED, {
            preferences: this.playControlPreferences,
            oldValues: oldValues,
        });
    };
    UserPlayControlService.prototype.doUpdateCall = function (preferences) {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, magic.methods.users.setPreferences(preferences)];
                    case 1:
                        _a.sent();
                        this.publishPreferences(preferences);
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        console.error(e_2);
                        window.eventBus.publish(USER_UPDATE_PREFERENCES_UPDATE_FAILED);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return UserPlayControlService;
}());

export { UserPlayControlService };
